import {
    hasMerchantOrganizationCapacity,
    type RoleAssignmentPermissionContext,
} from '@pillar-portal/api-types';

export function hasMerchantPaymentTransactionsPage(
    activeRoleAssignment: RoleAssignmentPermissionContext | null
): boolean {
    return hasMerchantOrganizationCapacity(activeRoleAssignment);
}

export function hasMerchantPaymentRequestsPage(
    activeRoleAssignment: RoleAssignmentPermissionContext | null
): boolean {
    return hasMerchantOrganizationCapacity(activeRoleAssignment);
}

export function hasMerchantCardVaultPage(
    activeRoleAssignment: RoleAssignmentPermissionContext | null
): boolean {
    return hasMerchantOrganizationCapacity(activeRoleAssignment);
}
